import { Add } from "@mui/icons-material";
import { Fab, FormControl } from "@mui/material";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import React, { useContext, useRef } from "react";
import { useLocation } from "react-router";
import { Option, VirtualizedAutocomplete } from "src/Components/Common/VirtualAutocomplete";
import { userContext } from "src/Components/Contexts/userContext";
import AddNewBusinessPartner from "../../NewBusinessPartner/AddNewBusinessPartner";
import { CommonAutoComplete } from "../../PartnerCommunication/CommonLegacy/CommonComponents";
import { Recon360Context } from "../../Recon360";

export default function PartnerSelectSection() {
  const location = useLocation<any>();
  const { actor } = useContext(userContext);
  const {
    businessPartnerSelected,
    businessPartnerSelect,
    listCompaniesForRecon,
    listBranchesForRecon,
    selectedCompany,
    selectedBranch,
    branchNameSelect,
    companyNameSelect,
    companiesLoaded,
    branchesLoaded,
    ownBusinessPartnersLoaded,
    selectedBusinessPartnerName,
    options,
    selectedBusinessPartnerVendorCode,
    listAllOwnBusinessPartnerMapping,
  } = useContext(Recon360Context);
  const addNewBpFunc = useRef(null);
  const optionsListCompaniesForRecon = listCompaniesForRecon?.map((option: any) => {
    const firstLetter = option.companyName[0]?.toUpperCase();
    return {
      firstLetter,
      ...option,
    };
  });
  const optionsListBranchForRecon = listBranchesForRecon?.map((option: any) => {
    const firstLetter = option.branchName[0]?.toUpperCase();
    return {
      firstLetter,
      ...option,
    };
  });

  return (
    <Grid container={true} xs={12}>
      <Grid md={12}>
        <div className="top_bar_container">
          <div className="business_content">
            {actor.integration === true && (
              <div className="width_30_per d_block">
                {/* company dropdown when actor.integration === true */}
                <CommonAutoComplete
                  lastSelected={selectedCompany}
                  onChangeSelectFn={(e, value) => companyNameSelect(e, value)}
                  optionsList={optionsListCompaniesForRecon}
                  optionLabelKey={"companyName"}
                  loaded={companiesLoaded}
                  label="Select Company"
                />
              </div>
            )}

            {actor.integration === true && actor.branchLevelReconcilation === true && (
              <div className="width_30_per d_block">
                {/* branch dropdown when  actor.branchLevelReconcilation === true */}
                <CommonAutoComplete
                  lastSelected={selectedBranch}
                  onChangeSelectFn={(e, value) => branchNameSelect(e, value)}
                  optionsList={optionsListBranchForRecon}
                  optionLabelKey={"branchName"}
                  loaded={branchesLoaded}
                  label="Branch / Plant / Unit"
                />
              </div>
            )}
            {/* Partner select dropdown always */}
            <div className="width_30_per d_block">
              <Card sx={{ p: "8px !important" }} style={{ position: "relative" }}>
                <VirtualizedAutocomplete
                  usedModule="recon"
                  loading={!ownBusinessPartnersLoaded}
                  options={options as Option[]}
                  value={
                    businessPartnerSelected
                      ? {
                          name: selectedBusinessPartnerName,
                          id: businessPartnerSelected,
                          vendorCode: selectedBusinessPartnerVendorCode,
                          firstLetter: selectedBusinessPartnerName[0]?.toUpperCase(),
                        }
                      : null
                  }
                  defaultValue={
                    location.state?.businessPartnerId
                      ? {
                          name: location.state?.businessPartnerName,
                          id: location.state?.businessPartnerId,
                          vendorCode: location.state?.vendorCode ? location.state?.vendorCode : "",
                          firstLetter: location.state?.businessPartnerName[0]?.toUpperCase(),
                        }
                      : null
                  }
                  onChange={(evt, value) => businessPartnerSelect(evt, value as Option)}
                />
              </Card>
            </div>

            {!actor.integration && (
              <div className="ml_10" style={{ position: "relative" }}>
                <AddNewBusinessPartner
                  listAllOwnBusinessPartnerMapping={listAllOwnBusinessPartnerMapping}
                  from={"Recon360"}
                  className={"theme_btn"}
                  component={
                    <FormControl sx={{ alignItems: "center" }}>
                      <Fab
                        // size="small"
                        color="primary"
                        aria-label="add business partner"
                        onClick={(_e) => addNewBpFunc.current && addNewBpFunc.current()}
                      >
                        <Add />
                      </Fab>
                    </FormControl>
                  }
                  onClick={(f) => (addNewBpFunc.current = f)}
                />
              </div>
            )}
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
